import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {HttpService} from '../../../core';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../core/services/user.service';
import {environment} from '../../../../environments/environment';


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})

export class EditUserComponent implements OnInit {
  reactiveForm: any;
  selectedFile: any;
  userId: any;
  companyId: any;
  user: any;
  SERVER_URL = environment.SERVER_URL;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private fb: FormBuilder,
              private httpService: HttpService,
              private userService: UserService,
              private toastrService: ToastrService) {
    this.reactiveForm = this.fb.group({
      email: [{value: '', disabled: true}],
      password: '',
      phone: '',
      firstName: '',
      lastName: '',
      role: [{value: '', disabled: true}],
      // status: [{value: '', disabled: true}]
    });
  }


  ngOnInit(): void {
    // this.userService.currentUser.subscribe((res: any) => {
    //   this.companyId = res.company.id;
    // });
    this.userService.currentUser.subscribe((r: any) => {
      console.log(r);
      this.user = r;
    });

    this.reactiveForm.patchValue({
      email: this.user.email,
      phone: this.user.phoneNumber,
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      role: this.user.roles[0].id,
      // status: this.user.status

    });
  }

  editUser() {
    const fd = new FormData();
    if (this.reactiveForm.get('password').value) {
      fd.append('password', this.reactiveForm.get('password').value);
    }
    fd.append('firstName', this.reactiveForm.get('firstName').value);
    fd.append('lastName', this.reactiveForm.get('lastName').value);
    if (this.reactiveForm.get('phone').value !== this.user.phoneNumber) {
      fd.append('phoneNumber', this.reactiveForm.get('phone').value);
    }
    this.httpService.editUser(fd).subscribe((r: any) => {
    
      if (r.code === 1) {
        this.toastrService.success('User profile has been updated');
      } else {
        this.toastrService.warning('Failed to update user profile');
      }
      console.log(1111)
      this.userService.getInfo()
    });
  }

  fileSelect(e) {
    console.log(e);
    this.selectedFile = e.target.files[0];
    console.log(this.selectedFile);
  }

  uploadAvatar() {
    if (!this.selectedFile) {
      return;
    } else {
      const fd = new FormData();
      fd.append('id', this.user.id);
      fd.append('headerImage', this.selectedFile);
      this.httpService.editUser(fd).subscribe((r: any) => {
        console.log(r);
        if (r.code === 1) {
          this.user = r.data;
          this.user.idOrigin = this.userService.getIdOrigin(r.data.contacts, r.data.passwordContactItem.id);
          this.toastrService.success('User avatar has been updated. Please refresh page.');
        } else {
          this.toastrService.error('Failed to update user avatar');
        }
        this.userService.getInfo()

      });
    }

  }

}
